var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompetition(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 161 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_225_35180)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 76.5,
    r: 76.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.171 70.1523L70.4191 78.4005L68.301 80.5186L62.171 74.3885L56.041 80.5186L53.9229 78.4005L62.171 70.1523Z",
    fill: "#177D84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5479 39L84.796 47.2481L82.6779 49.3662L76.5479 43.2362L70.4179 49.3662L68.2998 47.2481L76.5479 39Z",
    fill: "#177D84"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9268 82.1338L99.1749 90.3819L97.0568 92.5L90.9268 86.37L84.7968 92.5L82.6787 90.3819L90.9268 82.1338Z",
    fill: "#177D84"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.6725 115.404L60.6725 72.2695L63.668 72.2695L63.668 115.404L60.6725 115.404Z",
    fill: "#177D84"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0504 117.801L75.0505 41.1172L78.0459 41.1172L78.0459 117.801L75.0504 117.801Z",
    fill: "#177D84"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4294 113.009L89.4294 84.2529L92.4248 84.2529L92.4248 113.009L89.4294 113.009Z",
    fill: "#177D84"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0114 117.414C78.0814 118.223 77.4823 118.939 76.6711 118.972C69.2687 119.275 61.9692 117.027 56.0072 112.579C49.6515 107.838 45.2585 100.928 43.6623 93.1608C42.0662 85.3939 43.378 77.3113 47.3488 70.4479C51.0737 64.0096 56.895 59.0649 63.8168 56.4237C64.5753 56.1343 65.4082 56.5559 65.6629 57.3268V57.3268C65.9176 58.0977 65.4974 58.9257 64.7402 59.2186C58.5024 61.6313 53.2577 66.1058 49.8937 71.9203C46.2838 78.1599 45.0912 85.5079 46.5423 92.569C47.9934 99.63 51.9872 105.912 57.7652 110.222C63.1495 114.239 69.7337 116.283 76.4175 116.04C77.2289 116.01 77.9415 116.606 78.0114 117.414V117.414Z",
    fill: "#177D84"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9107 54.122C87.0886 53.3298 87.8762 52.8286 88.6595 53.0423C95.0165 54.7768 100.705 58.4156 104.95 63.4863C109.51 68.9333 112.15 75.7298 112.463 82.8267C112.776 89.9235 110.744 96.926 106.682 102.753C102.9 108.178 97.5536 112.303 91.374 114.591C90.6126 114.873 89.7839 114.443 89.5369 113.669V113.669C89.29 112.896 89.7184 112.072 90.4785 111.787C96.0436 109.698 100.857 105.967 104.27 101.072C107.963 95.7742 109.81 89.408 109.525 82.9562C109.241 76.5044 106.841 70.3255 102.695 65.3735C98.865 60.798 93.7417 57.5049 88.0144 55.9142C87.2321 55.6969 86.7328 54.9141 86.9107 54.122V54.122Z",
    fill: "#177D84"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_225_35180",
    x: 0,
    y: 0,
    width: 161,
    height: 161,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_225_35180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_225_35180",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetition);
export default __webpack_public_path__ + "static/media/competition.82b06abd907676523211b364736074b8.svg";
export { ForwardRef as ReactComponent };